/**
 * Pravilo pristupa audit zapisima predaja odgovora.
 *
 * Audit zapise smiju vidjeti ISKLJUČIVO Admin i Assessor role. Druge role
 * (npr. TermAdmin / exam term rola, ExamAdmin, QuestionAdmin...) NEMAJU pristup.
 * Backend isto provjerava preko permisije ANSWER_AUDIT_READ; ovo je UI sloj.
 */

/** Role kojima je dopušten pregled audit zapisa predaja odgovora. */
export const ANSWER_AUDIT_ROLES = ["Admin", "Assessor"] as const;

type RoleLike = { name?: string };
type UserLike = { applicationRoles?: RoleLike[] | null } | null | undefined;

/**
 * Vraća true samo ako korisnik ima Admin ili Assessor rolu.
 */
export function canViewAnswerAudit(user: UserLike): boolean {
  return !!user?.applicationRoles?.some(
    (role) => role.name === "Admin" || role.name === "Assessor"
  );
}
